import {
    REQUEST_PRODUCT_SURCHARGES,
    RECEIVE_PRODUCT_SURCHARGES,
    RECEIVE_PRODUCT_SURCHARGES_ERROR,
    REQUEST_CREATE_PRODUCT_SURCHARGE,
    RECEIVE_CREATE_PRODUCT_SURCHARGE,
    RECEIVE_CREATE_PRODUCT_SURCHARGE_ERROR,
    REQUEST_UPDATE_PRODUCT_SURCHARGE,
    RECEIVE_UPDATE_PRODUCT_SURCHARGE,
    RECEIVE_UPDATE_PRODUCT_SURCHARGE_ERROR,
    REQUEST_DELETE_PRODUCT_SURCHARGE,
    RECEIVE_DELETE_PRODUCT_SURCHARGE,
    RECEIVE_DELETE_PRODUCT_SURCHARGE_ERROR,
    DISMISS_PRODUCT_SURCHARGE_RESULT,
    RESET_PRODUCT_SURCHARGES,
    SEARCH_PRODUCT_SURCHARGE_QUERY,
} from '../actions/productSurcharges.js';

export const initState = {
    isFetching: false,
    isFetched:false,
    isError: false,
    isRequesting: false,
    isRequestingFinished: false,
    isDeletingFailed: false,
    productSurcharges: null,
    searchQuery: '',
};

export default function productSurcharges(state = initState, action) {
    switch (action.type) {
        case REQUEST_PRODUCT_SURCHARGES:
            return {
                ...state,
                isFetching: true,
                isError: false,
                isFetched:false
            };
        case RECEIVE_PRODUCT_SURCHARGES:
            return {
                ...state,
                isFetching: false,
                isFetched:true,
                isError: false,
                productSurcharges: action.productSurcharges,
                lastUpdate: action.receivedAt,
            };
        case RECEIVE_PRODUCT_SURCHARGES_ERROR:
            console.log(action.error);
            return {
                ...state,
                isFetching: false,
                isError: true,
                error: action.error.toString(),
            };
        case REQUEST_CREATE_PRODUCT_SURCHARGE:
            return {
                ...state,
                isRequesting: true,
                isRequestingFinished: false,
                error: '',
            };
        case RECEIVE_CREATE_PRODUCT_SURCHARGE:
            return {
                ...state,
                isRequesting: false,
                isRequestingFinished: true,
                error: '',
                productSurcharges: [action.productSurcharge, ...state.productSurcharges],
            };
        case RECEIVE_CREATE_PRODUCT_SURCHARGE_ERROR:
            console.log(action.error);
            return {
                ...state,
                isRequesting: false,
                isRequestingFinished: true,
                isError: true,
                error: action.error.toString(),
            };
        case REQUEST_UPDATE_PRODUCT_SURCHARGE:
            return {
                ...state,
                isRequesting: true,
                isRequestingFinished: false,
                error: '',
            };
        case RECEIVE_UPDATE_PRODUCT_SURCHARGE:
            return {
                ...state,
                isRequesting: false,
                isRequestingFinished: true,
                error: '',
                productSurcharges: [
                    action.productSurcharge,
                    ...state.productSurcharges.filter(productSurcharge => productSurcharge.id !== action.productSurcharge.id),
                ],
            };
        case RECEIVE_UPDATE_PRODUCT_SURCHARGE_ERROR:
            console.log(action.error);
            return {
                ...state,
                isRequesting: false,
                isRequestingFinished: true,
                isError: true,
                error: action.error.toString(),
            };
        case REQUEST_DELETE_PRODUCT_SURCHARGE:
            return {
                ...state,
                isRequesting: true,
                isRequestingFinished: false,
                error: '',
            };
        case RECEIVE_DELETE_PRODUCT_SURCHARGE:
            return {
                ...state,
                isRequesting: false,
                isRequestingFinished: true,
                error: '',
                productSurcharges: [...state.productSurcharges.filter(productSurcharge => productSurcharge.id !== action.id)],
            };
        case RECEIVE_DELETE_PRODUCT_SURCHARGE_ERROR:
            console.log(action.error);
            return {
                ...state,
                isRequesting: false,
                isRequestingFinished: true,
                isError: true,
                isDeletingFailed: true,
                error: action.error.toString(),
            };
        case DISMISS_PRODUCT_SURCHARGE_RESULT:
            return {
                ...state,
                isRequesting: false,
                isRequestingFinished: false,
                isError: false,
                isDeletingFailed: false,
                error: '',
            };
        case RESET_PRODUCT_SURCHARGES:
            return {
                ...initState,
            };
        case SEARCH_PRODUCT_SURCHARGE_QUERY:
            return {
                ...state,
                searchQuery: action.query,
            };
        default:
            return state;
    }
}
